/* tslint:disable */
/* eslint-disable */
/**
 * LTCS gateway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferAdditionalOptionsInner
 */
export interface OfferAdditionalOptionsInner {
    /**
     * 
     * @type {number}
     * @memberof OfferAdditionalOptionsInner
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    longDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    categoryDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfferAdditionalOptionsInner
     */
    categoryIdentifier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfferAdditionalOptionsInner
     */
    price?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferAdditionalOptionsInner
     */
    tags?: Array<string>;
}

/**
 * Check if a given object implements the OfferAdditionalOptionsInner interface.
 */
export function instanceOfOfferAdditionalOptionsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OfferAdditionalOptionsInnerFromJSON(json: any): OfferAdditionalOptionsInner {
    return OfferAdditionalOptionsInnerFromJSONTyped(json, false);
}

export function OfferAdditionalOptionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferAdditionalOptionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'longDescription': !exists(json, 'long_description') ? undefined : json['long_description'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'categoryDescription': !exists(json, 'category_description') ? undefined : json['category_description'],
        'categoryIdentifier': !exists(json, 'category_identifier') ? undefined : json['category_identifier'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
    };
}

export function OfferAdditionalOptionsInnerToJSON(value?: OfferAdditionalOptionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'long_description': value.longDescription,
        'value': value.value,
        'identifier': value.identifier,
        'category': value.category,
        'category_description': value.categoryDescription,
        'category_identifier': value.categoryIdentifier,
        'price': value.price,
        'tags': value.tags,
    };
}

